var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-heading card",class:_vm.width},[_c('h2',[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t\t"),(_vm.small)?[_c('br'),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.small))])]:_vm._e()],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }